// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popUp-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
}

.popUp-content {
	background-color: black;
	border-radius: 8px;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.popUp-pdf-content {
	height: 100%;
	overflow-x: auto;
	position: relative;
	border-radius: 8px;
	display: flex;
}
/* Hide scrollbar for webkit-based browsers (Chrome, Safari) */
.custom-scrollbar ::-webkit-scrollbar {
	display: none;
}
/* Hide scrollbar for Firefox */
.custom-scrollbar {
	scrollbar-width: none;
	-ms-overflow-style: none;
}

.custom-pop-up-scrollbar ::-webkit-scrollbar {
	width: 12px;
}

.custom-pop-up-scrollbar ::-webkit-scrollbar-thumb {
	background-color: #b5d425;
}

.custom-pop-up-scrollbar {
	scrollbar-width: thin;
	scrollbar-color: #b5d425 #f1f1f1;
}

.pdf-pop-up-container__canvas {
	width: 100% !important;
	height: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Dashboard/pdf-pop-up-view.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;AACd;AACA,8DAA8D;AAC9D;CACC,aAAa;AACd;AACA,+BAA+B;AAC/B;CACC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB","sourcesContent":[".popUp-container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\tbox-sizing: border-box;\n}\n\n.popUp-content {\n\tbackground-color: black;\n\tborder-radius: 8px;\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n}\n\n.popUp-pdf-content {\n\theight: 100%;\n\toverflow-x: auto;\n\tposition: relative;\n\tborder-radius: 8px;\n\tdisplay: flex;\n}\n/* Hide scrollbar for webkit-based browsers (Chrome, Safari) */\n.custom-scrollbar ::-webkit-scrollbar {\n\tdisplay: none;\n}\n/* Hide scrollbar for Firefox */\n.custom-scrollbar {\n\tscrollbar-width: none;\n\t-ms-overflow-style: none;\n}\n\n.custom-pop-up-scrollbar ::-webkit-scrollbar {\n\twidth: 12px;\n}\n\n.custom-pop-up-scrollbar ::-webkit-scrollbar-thumb {\n\tbackground-color: #b5d425;\n}\n\n.custom-pop-up-scrollbar {\n\tscrollbar-width: thin;\n\tscrollbar-color: #b5d425 #f1f1f1;\n}\n\n.pdf-pop-up-container__canvas {\n\twidth: 100% !important;\n\theight: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
